<template>
  <v-card class="p-2" outlined>
    <v-skeleton-loader
      v-bind="attrs"
      type="card-heading, image, actions"
      v-if="loading"
    />

    <div
      :class="{
        'hide-component': loading,
      }"
    >
      <card-chart-header
        :title="header.title"
        subtitle="pie is clickable"
        :getData="getData"
        :type="type"
        :class="{
          'mb-3': chartIsTeamProgress,
        }"
      />

      <v-combobox
        v-if="chartIsTeamProgress"
        v-model="selectedCategories"
        :items="categories"
        item-text="name"
        item-value="id"
        placeholder="Select Courses"
        clearable
        multiple
        small-chips
        dense
        @change="filterProgress"
        :loading="dateRangeLoading"
        :disabled="dateRangeLoading"
      />

      <div class="position-relative">
        <v-overlay absolute :value="overlay">
          <h4>No "Team's Progress" Data Found!</h4>
        </v-overlay>

        <GChart
          type="PieChart"
          :data="chartData"
          :options="chartOptions"
          :settings="{ packages: ['corechart'] }"
          :createChart="(el, google) => new google.visualization.PieChart(el)"
          :events="chartEvents"
          class="mr-5"
          ref="gchart"
          id="chart"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { every as _every, map as _map, debounce as _debounce } from 'lodash-es';
import CardChartHeader from '@/components/client-reports/widgets/CardChartHeader.vue';
import EventBus from '@/plugins/eventBus';

function defaultChartData() {
  return [['Assigned', 'Completed']];
}

export default {
  name: 'DonutChart',

  components: {
    CardChartHeader,
  },

  props: ['model', 'type', 'showChartDialog', 'getData'],

  data() {
    return {
      chartData: defaultChartData(),

      chartOptions: {
        title: '',
        titleTextStyle: {
          fontSize: 16,
          bold: false,
          color: '#757575',
        },
        subtitle: 'Sales, Expenses, and Profit: 2014-2017',
        pieHole: 0.6,
        chartArea: {
          width: '100%',
          height: '85%',
        },
        legend: {
          position: 'bottom',
          alignment: 'center',
        },
        slices: {
          0: { color: '#f9b418' },
          1: { color: '#bdbfc4' },
        },
      },

      chartEvents: {
        click: this.chartOnSelect,
        ready: this.toggleLoading,
      },

      header: {
        title: '',
      },

      selectedCategories: [],

      loading: true,

      overlay: false,
    };
  },

  computed: {
    chartIsTeamProgress() {
      return this.type === 'teamProgress';
    },

    dateRangeLoading() {
      return this.$store.state.overviewReport.dateRangeLoading;
    },

    categories() {
      return this.$store.state.overviewReport.reportData.categories;
    },
  },

  created() {
    EventBus.$on('reset', () => {
      this.resetAllFilters();
    });

    this.setComponentTitle();
  },

  methods: {
    chartOnSelect() {
      const data = this.$refs.gchart.getValidChartData();
      const table = this.$refs.gchart.chartObject;
      const selection = table.getSelection();

      for (let i = 0; i < selection.length; i++) {
        const item = selection[i];
        if (item.row === null && item.column === null) {
          continue;
        }

        const category = data.getValue(selection[0].row, 0);

        this.showChartDialog(this.type, category, this.header.title);
      }
    },

    initializeChart(title) {
      if (_every(this.model[this.type], (item) => item < 1)) {
        this.overlay = true;
        return;
      }

      this.overlay = false;

      this.chartData = defaultChartData();

      Object.keys(this.model[this.type]).forEach((key) => {
        this.chartData.push([key, this.model[this.type][key]]);
      });
    },

    filterProgress: _debounce(function () {
      const categories = _map(this.selectedCategories, (item) => item.id);
      this.getData(categories);
      this.$store.dispatch('overviewReport/setDateRangeLoading', true);
      this.$store.dispatch('overviewReport/setCategories', {
        type: this.type,
        value: categories,
      });
    }, 500),

    toggleLoading() {
      this.loading = false;
    },

    resetAllFilters() {
      this.selectedCategories = [];
    },

    setComponentTitle() {
      this.header.title =
        this.type === 'myProgress' ? 'My Progress' : "Team's Progress";
    },
  },
};
</script>

<style lang="stylus">
#chart
  height 400px
</style>
